import "./home.css";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { red, yellow } from "@mui/material/colors";

export function MapPreview() {
  const EMBED_URL =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5040.663620290018!2d-0.1393459!3d50.825017599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4875857533e51477:0xe73b8c65377efef0!2sLUST%2021%20Brighton%20%26%20Hove%27s%20sex%20shop!5e0!3m2!1sen!2sde!4v1764107460696!5m2!1sen!2sde";

  return (
    <iframe
      className="map-preview"
      title="Lust Brighton Map"
      src={EMBED_URL}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}

const worksStepsData = [
  {
    description: `Meet your host at Lust!
                  Brighton and Hove’s sex shop,43 Gardner St, Brighton and Hove,
                  Brighton BN1 1UN.`,
    type: "map",
  },
  {
    description: `Enjoy a private tour of the boutique, where your host 
                  will explain history of sex shops and give you a peek at the shop's cheeky treasure.`,
    imageSrc: "./about3.jpg",
    type: "image",
  },
  {
    description: ` Play hilarious hen games
                  and win adult prizes.`,
    imageSrc: "./about5.png",
    type: "image",
  },
  {
    description: `Follow a flirty treasure hunt
                  through Brighton’s streets:
                  Uncover outrageous stories, Hidden histories, and scandalous secrects around every corner.`,
    imageSrc: "./about4.png",
    type: "image",
  },
];

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className="home-page">
      {/* HERO / FIRST HALF */}
      <div className="home-container">
        <div className="right-pane">
          <img src="./home_image_5.png" alt="Brighton experience" className="hero-img" />
        </div>

        <div className="left-pane">
          <h1 className="tagline">
            Brighton's <em>Best</em> Hen Party Experience!
          </h1>

          <p className="description">
            Say goodbye to the single life with a whistlestop tour around Brighton’s sexual history.
            Enjoy a private tour of an iconic Brighton adult boutique, play wild hen games and win
            x-rated prizes, then uncover the city’s naughtiest secrets on a hilarious treasure hunt!
          </p>

          <Button className="book-button" onClick={() => navigate("/book-now")}>
            BOOK NOW
          </Button>
        </div>
      </div>

      {/* SECOND HALF: HOW IT WORKS + REVIEWS */}
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          background: {
            xs: "#88cfef",
            md: "linear-gradient(to right, #88cfef 50%, #E7E7E7 50%)",
          },
        }}
      >
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          size={{ xs: 12, md: 6 }}
          sx={{
            pt: { xs: 4, md: 6 },
          }}
        >
          <h2 className="section-title">
            How it <em>works</em>
          </h2>
          <div className="steps-list">
            {worksStepsData.map((step, index) => (
              <Grid
                container
                direction={"row"}
                alignItems={"center"}
                sx={{
                  justifyContent: { xs: "center", sm: "space-between", md: "space-between" },
                }}
                spacing={{ xs: 2, md: 8 }}
                key={index}
              >
                <Grid item size={{ xs: 10, sm: 5, md: 6 }} className="step-image-container">
                  {step.type === "image" ? (
                    <img src={step.imageSrc} alt="Boutique tour" className="step-image" />
                  ) : (
                    <MapPreview />
                  )}
                </Grid>
                <Grid item size={{ xs: 12, sm: 7, md: 6 }}>
                  <p className="step-text">{step.description}</p>
                </Grid>
              </Grid>
            ))}
          </div>
        </Grid>

        {/* RIGHT: REVIEWS */}
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          size={{ xs: 12, md: 6 }}
          sx={{
            background: { xs: "#E7E7E7", md: "transparent" },
            pt: { xs: 4, md: 6 },
          }}
        >
          <h2 className="section-title">Reviews</h2>
          <div className="reviews-inner">
            <div className="review">
              <div className="review-stars">★★★★★</div>
              <p className="review-text">
                “We loved the mix of in-person and self-guided parts! …Learnt some really
                interesting facts. Recommend.”
              </p>
              <p className="review-meta">— Sarah, Verified review via GetYourGuide (Oct 2025))</p>
            </div>

            <div className="review">
              <div className="review-stars">★★★★★</div>
              <p className="review-text">
                “What an experience! It was well worth the money and it was a super fun and well
                crafted… Thanks for a great couple of hours guys! :)”
              </p>
              <p className="review-meta">
                — Elliese, Verified review via GetYourGuide (Sept 2025))
              </p>
            </div>

            <div className="review">
              <div className="review-stars">★★★★★</div>
              <p className="review-text">
                “We had so much fun! Learned so many interesting and unusual things about Brighton.
                Highly recommended!”
              </p>
              <p className="review-meta">— Adrian, Verified review via GetYourGuide (Aug 2025)</p>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* CONTACT SECTION */}
      <div className="contact-section">
        <div className="contact-content">
          {/* LEFT: WhatsApp section */}
          <Grid container direction="column" alignItems={"center"}>
            <h2 className="contact-title">
              Wanna <em>chat?</em>
            </h2>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <a
                href="https://wa.me/447985755900"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <img src="./whatsapp2.png" alt="WhatsApp" className="whatsapp-icon" />
              </a>
              <div>
                <p className="contact-text">
                  Click the button to WhatsApp
                  <br />a real person at Puzzle Panda.
                  <br />
                  <br />
                  We're here to answer all your
                  <br />
                  questions and help you plan
                  <br />
                  an incredible hen party!
                </p>
              </div>
            </Grid>
          </Grid>

          {/* RIGHT: Email section */}
          <Grid container direction="column" alignItems={"start"}>
            <p className="email-label">Or if you prefer email, contact:</p>

            <p className="email-address">hazel@puzzlepanda.co</p>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Home;
